/**
 * 【KYMW1407】使用履歴一覧取得VO
 *
 * @export GetUseRecordListModel
 * @class GetUseRecordListModel
 */
export class GetUseRecordListModel {
  // コマID
  public coopCode = String('');
  // Pコード
  public pcode = String('');
  // 今回受注コード
  public thisOrderCode = String('');
}
